import proxy from "../proxy";
import Logger from "./Logger";

const logger = new Logger(__filename);
// TODO: refactorizar
const requestServer = (url, proxied, request, options = {}) =>
  fetch(url, { ...options })
    .then(response => {
      if (response.status !== 200) {
        logger.error(`${request} Looks like there was a problem. Status Code: ${response.status}`);
      } else {
        return response.json();
      }
    })
    .then(proxied)
    .catch(proxied);

const ajax = {
  request: 0,
  get(url, success, error = success, options = {}) {
    const request = `get-${this.request++}`;
    logger.log(`${request} requesting ${url}...`);
    const proxied = proxy.proxy(request, data => {
      logger.log(`${request} receiving ${url}...`);
      if (/mock/.test(url)) {
        data = `${request} ${new Date()}`;
      }
      if (data) {
        success(data);
      } else {
        error();
      }
    });
    if (!/mock/.test(url)) {
      requestServer(url, proxied, request, options);
    } else {
      setTimeout(proxied, Math.random() * 1000);
    }
  },
  put(url, success, error = success, changes) {
    const request = `get-${this.request++}`;
    logger.log(`${request} requesting ${url}...`);
    const proxied = proxy.proxy(request, data => {
      logger.log(`${request} receiving ${url}...`);
      if (/mock/.test(url)) {
        data = `${request} ${new Date()}`;
      }
      if (data) {
        success(data);
      } else {
        error();
      }
    });
    if (!/mock/.test(url)) {
      fetch(url, {
        method: "PUT",
        body: JSON.stringify(changes), // data can be `string` or {object}!
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      })
        .then(response => {
          if (response.status !== 200) {
            logger.error(`${request} Looks like there was a problem. Status Code: ${response.status}`);
          } else {
            return response.json();
          }
        })
        .then(proxied);
    } else {
      setTimeout(proxied, Math.random() * 1000);
    }
  },
};

export default ajax;
